export default function FormCard({ children, style }) {
	return (
		<div className='form-card' style={style}>
			{children}
		</div>
	);
}
